export const Identity = 'identity';

export const Linear = 'linear';
export const Log = 'log';
export const Pow = 'pow';
export const Sqrt = 'sqrt';
export const Symlog = 'symlog';

export const Time = 'time';
export const UTC = 'utc';

export const Sequential = 'sequential';
export const Diverging = 'diverging';

export const Quantile = 'quantile';
export const Quantize = 'quantize';
export const Threshold = 'threshold';

export const Ordinal = 'ordinal';
export const Point = 'point';
export const Band = 'band';
export const BinOrdinal = 'bin-ordinal';

// categories
export const Continuous = 'continuous';
export const Discrete = 'discrete';
export const Discretizing = 'discretizing';
export const Interpolating = 'interpolating';
export const Temporal = 'temporal';
